/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_heomoney/helpers'
import LanguageButton from '../widgets/components/LanguageButton'
import {useIntl} from 'react-intl'

const AuthLayout = () => {
  const intl = useIntl()
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-50'>
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 order-2 order-lg-1'>
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
        </div>

        <div className='d-flex flex-center flex-wrap'>
          <div className='d-flex fw-semibold flex-center text-primary fs-base mb-5'>
            <LanguageButton />

            <a href='#' className='px-2' target='_blank'>
              {intl.formatMessage({id: 'TERMINOS'})}
            </a>

            <a href='#' className='px-2' target='_blank'>
              {intl.formatMessage({id: 'PLANES'})}
            </a>

            <a href='#' className='px-2' target='_blank'>
              {intl.formatMessage({id: 'CONTACTANOS'})}
            </a>
          </div>
        </div>
      </div>

      <div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'>
        <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
          <img
            className='mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20'
            src={toAbsoluteUrl('/media/logos/img-backoffice.png')}
            alt=''
          />
        </div>
      </div>
    </div>
  )
}

export {AuthLayout}
